import React from 'react'
import {GoogleLogin} from 'react-google-login'
import store from '../redux'

const clientId = '389209335738-hqmub5i0hcq796ug9be3f3jhr47stm53.apps.googleusercontent.com'

function Login () {
    const onSuccess = (res) => {
        store.dispatch({type:'USER_LOGIN', newData: res.profileObj})
        console.log('[Login Success]')

        let refreshTiming = (res.tokenObj.expires_in || 3600 - 5 * 60) * 1000;
        const refreshToken = async () => {
            const newAuthRes = await res.reloadAuthResponse();
            refreshTiming = (newAuthRes.expires_in || 3600 - 5 * 6) * 1000;
            // console.log('newAuthRes :', newAuthRes)
            // saveUserToken(newAuthRes.access_token);  <-- save new token
            // console.log('new auth token', newAuthRes.id_token)
            setTimeout(refreshToken, refreshTiming)
        }
        setTimeout(refreshToken, refreshTiming)
    }

    const onFailure = (res) => {
        console.log('[Login Failed] res: ', res)
    }

    return (
        <div>
            <GoogleLogin
                clientId={clientId}
                render={renderProps => (
                    <button className="btn btn-info btn-lg btn-block" onClick={renderProps.onClick} disabled={renderProps.disabled}>Masuk</button>
                  )}
                buttonText="Login"
                onSuccess={onSuccess}
                onFailure={onFailure}
                cookiePolicy={'single_host_origin'}
                isSignedIn={true}
            />
        </div>
    )
}

export default Login